import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAward = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.25 10a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.75 14.75-1 4.5 4.25-1.5 4.25 1.5-1-4.5"
    />
  </svg>
);
export default SvgAward;
